"use client";

import { c as _c } from "react/compiler-runtime";
import { useMDXComponents } from "mdx-components";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type * as React from "react";
import { Page } from "timvir/core";
import { defaultSearch, Search } from "timvir/search";
import toc from "../../timvir/toc";
const search: React.ComponentPropsWithoutRef<typeof Page>["search"] = {
  Component: function Component(props) {
    return <Search {...props} {...defaultSearch(toc)} />;
  }
};
const navigation: React.ComponentPropsWithoutRef<typeof Page>["navigation"] = {
  usePathname,
  Link: props => <Link {...props} prefetch={false} />
};
interface Props {
  children: React.ReactNode;
}
export default function Layout(props) {
  const $ = _c(3);
  const {
    children
  } = props;
  const t0 = useMDXComponents();
  let t1;
  if ($[0] !== children || $[1] !== t0) {
    t1 = <Page navigation={navigation} toc={toc} search={search} mdxComponents={t0}>{children}</Page>;
    $[0] = children;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}